<!-- splash screen -->
<div #splashScreen class="m-splash-screen" aria-hidden="true">
  <!-- <img [attr.src]="splashScreenImage" style="width: 290px; margin-bottom: 20px;"> -->
  <mat-spinner diameter="50"></mat-spinner>
</div>
<router-outlet></router-outlet>
